import Modal from 'react-modal';
import React from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { modalActions } from '../../redux/root-action';
import ContentModalWrapper from './ContentModalWrapper';
import styled from 'styled-components';

const desktopStyles = {
  content: {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '640px',
    padding: 0,
    maxHeight: '506px',
    boxShadow: '0 16px 16px 0 rgba(45, 57, 64, 0.06), 0 0 8px 0 rgba(45, 57, 64, 0.06)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 2000,
  },
};

const mobileStyles = {
  overlay: {
    position: 'fixed' as 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    zIndex: 2000,
  },
  content: {
    position: 'absolute' as 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch' as 'touch',
    borderRadius: 4,
    outline: 'none',
    padding: 0,
    height: '100vh',
  },
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  @media only screen and (max-width: 767px) {
    height: 100vh;
    width: 100%;
  }
`;

const StyledHeader = styled.div`
  border-radius: 4px;
`;
const StyledContent = styled.div`
  overflow: auto;
  flex-grow: 1;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey800};
`;

const CloseIcon = styled.img`
  float: right;
  padding: 24px 24px 0px 0px;

  @media (max-width: 767px) {
    position: absolute;
    right: 0;
  }
`;

class ContentModal extends React.Component<any> {
  props: any;
  render(): any {
    const mq = window.matchMedia('(max-width: 767px)');
    const { hideModal, pageUrl } = this.props;
    return (
      <div>
        <Modal
          shouldCloseOnOverlayClick={true}
          isOpen={true}
          onRequestClose={hideModal}
          contentLabel="Modal"
          style={mq.matches ? mobileStyles : desktopStyles}
        >
          <StyledContainer>
            <StyledHeader>
              <CloseIcon
                onClick={hideModal}
                src={`data:image/svg+xml;base64,${tokens.AssetIconClose}`}
                alt="Close icon"
              />
            </StyledHeader>
            <StyledContent>
              <ContentModalWrapper pageUrl={pageUrl} />
            </StyledContent>
          </StyledContainer>
        </Modal>
      </div>
    );
  }
}

export default connect(null, { hideModal: modalActions.hideModal })(ContentModal);
